var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6",domProps:{"innerHTML":_vm._s(_vm.leftPanelInfo)}}),_vm._v(" "),_c('div',{staticClass:"col-md-6",domProps:{"innerHTML":_vm._s(_vm.rightPanelInfo)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }